var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
import BigNumber from 'bignumber.js';
import numeral from 'numeral';
import 'numeral/locales';
import parseDecimalNumber from 'parse-decimal-number';
var makeBigNumber = function makeBigNumber(value) {
  return new BigNumber(isNaN(value) ? 0 : value);
};
var NumberFormatter = function () {
  function NumberFormatter() {
    _classCallCheck(this, NumberFormatter);
    this.locale = null;
    this.abbreviations = null;
    this.delimiters = null;
    this.getDecimalPlaces = null;
  }

  /**
   * @param {Object} options
   * @param {String} options.locale
   * @param {Function} options.getDecimalPlaces
   */

  _createClass(NumberFormatter, [{
    key: 'init',
    value: function init(options) {
      this.locale = options.locale;
      this.getDecimalPlaces = options.getDecimalPlaces;
      var _getLocaleSettings = this.getLocaleSettings(),
        delimiters = _getLocaleSettings.delimiters,
        abbreviations = _getLocaleSettings.abbreviations;
      this.abbreviations = abbreviations;
      this.delimiters = delimiters;
      BigNumber.config({
        ROUNDING_MODE: options.roundingMode ? options.roundingMode : BigNumber.ROUND_FLOOR,
        FORMAT: {
          decimalSeparator: delimiters.decimal,
          groupSeparator: delimiters.thousands,
          groupSize: 3
        }
      });
    }
  }, {
    key: 'currency',
    value: function currency(value, symbol) {
      var currency = makeBigNumber(value);
      currency.symbol = symbol;
      return currency;
    }
  }, {
    key: 'formatPercentageValue',
    value: function formatPercentageValue(value) {
      var number = makeBigNumber(value);
      return number.toFormat(2) + '%';
    }
  }, {
    key: 'formatToThousands',
    value: function formatToThousands(value) {
      var number = makeBigNumber(value);
      return '' + number.div(1000).toFormat(2) + this.abbreviations.thousand;
    }

    /**
     *
     * @param {string|number|BigNumber} value
     * @param {string|number} symbolOrDecimals
     */
  }, {
    key: 'formatNumberToLocale',
    value: function formatNumberToLocale(value, symbolOrDecimals) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        removeTrailingZeroes: false
      };
      var num = makeBigNumber(value);
      var decimals = void 0;
      if (typeof symbolOrDecimals === 'string') {
        var decimalPlaces = this.getDecimalPlaces();
        decimals = decimalPlaces[symbolOrDecimals];
      } else {
        decimals = symbolOrDecimals;
      }
      if (options.removeTrailingZeroes) return num.decimalPlaces(decimals).toString();
      return num.toFormat(decimals);
    }
  }, {
    key: 'parseNumberToLocale',
    value: function parseNumberToLocale(value, localeOverride) {
      var negativeIsNaN = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var settings = this.getLocaleSettings(localeOverride);
      var reg = new RegExp('\\' + settings.delimiters.thousands, 'g');
      var formatValue = value.toString().replace(reg, '');
      if (formatValue === '' || formatValue === settings.delimiters.decimal) return 0;
      var parsed = parseDecimalNumber(formatValue, settings.delimiters);
      return negativeIsNaN && parsed < 0 ? NaN : parsed;
    }
  }, {
    key: 'replaceZeroWithDash',
    value: function replaceZeroWithDash(value) {
      return value === 0 ? '-' : value;
    }
  }, {
    key: 'truncateToDecimals',
    value: function truncateToDecimals(value, decimalPlaces) {
      var roundingMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var number = makeBigNumber(value);
      return number.decimalPlaces(decimalPlaces, roundingMode);
    }
  }, {
    key: 'getParsedDecimal',
    value: function getParsedDecimal(value, decimalPlaces) {
      var localeOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      // returns an object useful for complex rendering of decimal values
      var _ref = localeOverride ? this.getLocaleSettings(localeOverride).delimiters : this.delimiters,
        thousands = _ref.thousands,
        decimal = _ref.decimal;
      var BN = localeOverride ? BigNumber.clone({
        FORMAT: {
          decimalSeparator: decimal,
          groupSeparator: thousands,
          groupSize: 3
        }
      }) : BigNumber;
      var bigNum = new BN(isNaN(value) ? 0 : value);
      var parts = bigNum.toFormat().split(decimal);
      var units = parts[0];
      var decimals = parts.length > 1 && parts[1].length ? parts[1] : '0';
      if (decimals.length > decimalPlaces) {
        // concat
        decimals = decimals.substr(0, decimalPlaces);
      }
      var padding = decimals.length < decimalPlaces ? '0'.repeat(decimalPlaces - decimals.length) : '';
      return {
        negative: bigNum.isNegative(),
        units: units,
        decimalSeparator: decimal,
        decimals: decimals,
        padding: padding
      };
    }
  }, {
    key: 'getLocaleSettings',
    value: function getLocaleSettings() {
      var localeOverride = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var localeCode = localeOverride || this.locale;
      var settings = void 0;
      try {
        // numberal keys for locales can be without country code (e.g "en")
        settings = numeral.localeData(localeCode);
      } catch (e) {
        try {
          settings = numeral.localeData(localeCode.split('-')[0]);
        } catch (e) {
          // there can be the case that numeral doesn't have key for only lang code (e.g for pt key is pt-pt)
          settings = numeral.localeData(localeCode + '-' + localeCode);
        }
      }
      return settings;
    }
  }]);
  return NumberFormatter;
}();
var numberFormatter = new NumberFormatter();
export var init = numberFormatter.init.bind(numberFormatter);
export var currency = numberFormatter.currency.bind(numberFormatter);
export var formatPercentageValue = numberFormatter.formatPercentageValue.bind(numberFormatter);
export var formatToThousands = numberFormatter.formatToThousands.bind(numberFormatter);
export var formatNumberToLocale = numberFormatter.formatNumberToLocale.bind(numberFormatter);
export var parseNumberToLocale = numberFormatter.parseNumberToLocale.bind(numberFormatter);
export var replaceZeroWithDash = numberFormatter.replaceZeroWithDash.bind(numberFormatter);
export var truncateToDecimals = numberFormatter.truncateToDecimals.bind(numberFormatter);
export var getParsedDecimal = numberFormatter.getParsedDecimal.bind(numberFormatter);
export var getLocaleSettings = numberFormatter.getLocaleSettings.bind(numberFormatter);